import React, { lazy, Suspense } from 'react';
import Loader from '../../components/Loader/Loader.lazy';
const LazyCatalogueHome = lazy(() => import('./CatalogueHome'));

const CatalogueHome = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyCatalogueHome {...props} />
  </Suspense>
);

export default CatalogueHome;
